import { useContext } from 'react';

import SidebarContext from '../../context/sidebar/context';
import useStorePinnedApps from '../../hooks/useStorePinnedApps';
import { MenuItemType } from '../../types/menu-item';
import { getFeaturePath } from '../../utils/pathUtils';

import SectionHeading from './SectionHeading';
import SidebarMenuItem from './SidebarMenuItem';

interface ExpandableSectionProps {
  title: string;
  items: MenuItemType[];
  featurePath: string;
  pinnedApps: MenuItemType[];
  allowHighlight?: boolean;
  onNavigate?: (href: string) => void;
  titleLink?: string;
  onTitleClick?: (route: string) => void;
}

export default function ExpandableSection({
  title,
  items,
  featurePath,
  pinnedApps,
  allowHighlight = true,
  onNavigate,
  titleLink,
  onTitleClick,
}: ExpandableSectionProps) {
  const { expandedSections, toggleSection } = useContext(SidebarContext);
  const isExpanded = expandedSections?.[title] || false;
  const { isItemPinned } = useStorePinnedApps();

  return (
    <li className="space-y-1">
      <SectionHeading
        isExpanded={isExpanded}
        setIsExpanded={() => toggleSection?.(title)}
        text={title}
        titleLink={titleLink}
        onTextClick={onTitleClick}
      />
      {!isExpanded && (
        <ul className="space-y-1">
          {items.map((item) => (
            <SidebarMenuItem
              key={item.href}
              isPinned={isItemPinned(item, pinnedApps)}
              item={item}
              shouldHighlight={
                allowHighlight && featurePath === getFeaturePath(item.href)
              }
              onNavigate={onNavigate}
            />
          ))}
        </ul>
      )}
    </li>
  );
}
